// fancybox
document.addEventListener("DOMContentLoaded", function () {
    Fancybox.bind("[data-fancybox]", {});
});

// inputmask
document.addEventListener("DOMContentLoaded", function () {
    const formPhones = document.querySelectorAll('*[data-type-input="user_phone"]');
    formPhones.forEach(function (input) {
        Inputmask({ mask: "+7 (999) 999-99-99" }).mask(input);
    });
    const personalPhones = document.querySelectorAll('*[name="PERSONAL_PHONE"]');
    personalPhones.forEach(function (input) {
        Inputmask({ mask: "+7 (999) 999-99-99" }).mask(input);
    });
    const registerPhones = document.querySelectorAll('*[name="REGISTER[PERSONAL_PHONE]"]');
    registerPhones.forEach(function (input) {
        Inputmask({ mask: "+7 (999) 999-99-99" }).mask(input);
    });
});

// mobile menu
document.addEventListener("DOMContentLoaded", function () {
    const mobileMenuButtonOpen = document.querySelector(".mobile-menu-open");
    const mobileMenuButtonClose = document.querySelector(".mobile-menu-close");
    const mobileMenu = document.querySelector(".mobile-menu");
    const body = document.querySelector("body");
    const overlay = document.querySelector(".overlay");

    if (mobileMenuButtonOpen) {
        mobileMenuButtonOpen.addEventListener("click", function (event) {
            event.stopPropagation();
            event.preventDefault();
            mobileMenu.classList.toggle("is-open");
            overlay.classList.toggle("is-active");
            body.classList.toggle("is-fixed");
        });
    }

    if (mobileMenuButtonClose) {
        mobileMenuButtonClose.addEventListener("click", function (event) {
            event.stopPropagation();
            event.preventDefault();
            mobileMenu.classList.remove("is-open");
            overlay.classList.remove("is-active");
            body.classList.remove("is-fixed");
        });
    }

    if (overlay) {
        overlay.addEventListener("click", function (event) {
            event.stopPropagation();
            event.preventDefault();
            mobileMenu.classList.remove("is-open");
            overlay.classList.remove("is-active");
            body.classList.remove("is-fixed");
        });
    }

    const parentItems = document.querySelectorAll(".mobile-menu-nav .parent");

    parentItems.forEach(function (parentItem) {
        const arrow = parentItem.querySelector(".arrow");
        const submenu = parentItem.querySelector("ul");

        if (arrow && submenu) {
            arrow.addEventListener("click", function (event) {
                event.preventDefault();
                arrow.classList.toggle("is-rotate");
                submenu.classList.toggle("is-open");
            });
        }
    });
});

// tabs
document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll('[role="tab"]');
    const tabPanels = Array.from(document.querySelectorAll('[role="tabpanel"]'));

    function tabToggleAttribute(elements, attribute, value) {
        elements.forEach((element) => {
            element.setAttribute(attribute, value);
        });
    }

    function tabShowContent(e) {
        const id = this.id;

        tabToggleAttribute(tabPanels, "hidden", true);
        tabToggleAttribute(tabButtons, "aria-selected", false);
        tabToggleAttribute([this], "aria-selected", true);
        const tabPanel = tabPanels.find((panel) => panel.getAttribute("aria-labelledby") === id);
        tabPanel.hidden = false;
    }

    tabButtons.forEach((button) => {
        button.addEventListener("click", tabShowContent);
    });
});

// catalog menu
document.addEventListener("DOMContentLoaded", function () {
    const menuButton = document.getElementById("menu-catalog-button");
    const menuCatalog = document.querySelector(".menu-catalog");

    if (menuButton) {
        menuButton.addEventListener("click", function (event) {
            event.stopPropagation();
            event.preventDefault();
            menuButton.classList.toggle("is-active");
            menuCatalog.classList.toggle("is-open");
        });
    }

    document.addEventListener("click", function (event) {
        if (!menuButton.contains(event.target) && !menuCatalog.contains(event.target)) {
            menuButton.classList.remove("is-active");
            menuCatalog.classList.remove("is-open");
        }
    });
});

// cookie
document.addEventListener("DOMContentLoaded", function () {
    // Функция для установки куки
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    // Функция для получения значения куки
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // Функция для показа всплывающего окна
    function showCookiePopup() {
        var popup = document.getElementById("cookie-popup");

        if (popup) {
            popup.style.display = "flex";
        }
    }

    // Функция для закрытия всплывающего окна и установки куки
    function acceptCookies() {
        var popup = document.getElementById("cookie-popup");

        if (popup) {
            popup.style.display = "none";
            setCookie("cookie_accepted", "true", 365); // Устанавливаем куку на 365 дней
        }
    }

    // Показываем всплывающее окно только если кука не установлена
    if (getCookie("cookie_accepted") !== "true") {
        showCookiePopup();
    }

    // Обработчик события для кнопки "Принять"
    var cookieАccept = document.getElementById("cookie-accept");
    if (cookieАccept) {
        cookieАccept.addEventListener("click", function () {
            acceptCookies();
        });
    }
});

// popups
document.addEventListener("DOMContentLoaded", function () {
    const popupCallback = document.querySelectorAll('*[data-src="callback-popup"]');
    if (popupCallback) {
        popupCallback.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                Fancybox.show([
                    {
                        src: "#callback-popup",
                        type: "inline",
                    },
                ]);
            });
        });
    }
    const popupCalculate = document.querySelectorAll('*[data-src="calculate-popup"]');
    if (popupCalculate) {
        popupCalculate.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                Fancybox.show([
                    {
                        src: "#calculate-popup",
                        type: "inline",
                    },
                ]);
            });
        });
    }
});

// scroll to top
document.addEventListener("DOMContentLoaded", function () {
    function checkScroll() {
        var scrollTopElement = document.getElementById("scroll-top");

        if (scrollTopElement) {
            if (window.pageYOffset > 100) {
                scrollTopElement.classList.add("is-active");
            } else {
                scrollTopElement.classList.remove("is-active");
            }
        }
    }

    window.addEventListener("scroll", checkScroll);
    checkScroll();

    var scrollTopElement = document.getElementById("scroll-top");

    if (scrollTopElement) {
        scrollTopElement.addEventListener("click", function () {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        });
    }
});

// nice-select
document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("#sortField")) {
        NiceSelect.bind(document.querySelector("#sortField"));
    }

    const userGroupSelects = document.querySelectorAll('*[name="group_id"]');
    if (userGroupSelects) {
        userGroupSelects.forEach(function (select) {
            NiceSelect.bind(select);
        });
    }
});

// sliders
document.addEventListener("DOMContentLoaded", function () {
    // Gallery swiper
    var gallerySlider = new Swiper(".gallery", {
        spaceBetween: 16,
        autoHeight: true,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
        },
    });

    // Projects swiper
    var projectsGalleryThumbsSlider = new Swiper(".projects-gallery-thumbs", {
        direction: "vertical",
        spaceBetween: 12,
        slidesPerView: 3,
        slidesPerGroup: 3,
        mousewheel: {
            enabled: true,
        },
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".projects-gallery-thumbs-button-next",
            prevEl: ".projects-gallery-thumbs-button-prev",
        },
        breakpoints: {
            640: {},
            768: {},
            1024: {},
            1280: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 12,
            },
        },
    });
    var projectsGallerySlider = new Swiper(".projects-gallery-main", {
        spaceBetween: 16,
        effect: "fade",
        loop: true,
        navigation: {
            nextEl: ".projects-gallery-main-button-next",
            prevEl: ".projects-gallery-main-button-prev",
        },
        thumbs: {
            swiper: projectsGalleryThumbsSlider,
        },
    });

    // Section swiper
    var sectionSlider = new Swiper(".section-slider", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
        observer: true,
        watchOverflow: true,
        watchSlidesProgress: true,
        speed: 1000,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 16,
            },
            1280: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 16,
            },
        },
    });

    // Функции для YouTube (оставляем без изменений)
    function getYouTubeThumbnailUrl(videoId) {
        return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    }

    function getYouTubeVideoId(url) {
        if (!url) return null;
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        return match ? match[1] : null;
    }

    // Новые функции для Rutube
    function getRutubeVideoId(url) {
        const regex = /https:\/\/rutube\.ru\/play\/embed\/([a-zA-Z0-9_-]+)/;
        const match = url.match(regex);
        return match ? match[1] : null;
    }

    function getRutubeThumbnailUrl(videoId) {
        return `https://preview.rutube.ru/preview/${videoId}.webp`;
    }

    // Установка миниатюр для видео (YouTube и Rutube)
    document.querySelectorAll(".yt-thumb-container").forEach(function (container) {
        const videoSrc = container.getAttribute("data-src");
        if (videoSrc) {
            let thumbnailUrl;
            if (videoSrc.includes("youtube.com") || videoSrc.includes("youtu.be")) {
                const videoId = getYouTubeVideoId(videoSrc);
                if (videoId) {
                    thumbnailUrl = getYouTubeThumbnailUrl(videoId);
                } else {
                    console.error(`Invalid YouTube URL: ${videoSrc}`);
                }
            } else if (videoSrc.includes("rutube.ru")) {
                const videoId = getRutubeVideoId(videoSrc);
                if (videoId) {
                    thumbnailUrl = getRutubeThumbnailUrl(videoId);
                } else {
                    console.error(`Invalid Rutube URL: ${videoSrc}`);
                }
            } else {
                console.error(`Unsupported video platform: ${videoSrc}`);
            }
            if (thumbnailUrl) {
                const thumbnailImg = container.querySelector(".yt-thumbnail");
                thumbnailImg.src = thumbnailUrl;
            }
        } else {
            console.error("Missing data-src attribute");
        }
    });

    // Инициализация слайдеров
    var productGalleryThumbsSlider = new Swiper(".product-gallery-thumbs", {
        direction: "vertical",
        spaceBetween: 8,
        slidesPerView: 5,
        slidesPerGroup: 5,
        mousewheel: {
            enabled: true,
        },
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".product-gallery-thumbs-button-next",
            prevEl: ".product-gallery-thumbs-button-prev",
        },
    });

    var productGallerySlider = new Swiper(".product-gallery-main", {
        spaceBetween: 10,
        effect: "fade",
        navigation: {
            nextEl: ".product-gallery-main-button-next",
            prevEl: ".product-gallery-main-button-prev",
        },
        thumbs: {
            swiper: productGalleryThumbsSlider,
        },
        on: {
            slideChange: function () {
                const activeSlide = this.slides[this.activeIndex];
                const videoContainer = activeSlide.querySelector(".yt-container");

                // Если активный слайд содержит видео
                if (videoContainer && !videoContainer.classList.contains("loaded")) {
                    const videoSrc = videoContainer.getAttribute("data-src");
                    let iframeSrc;

                    if (videoSrc.includes("youtube.com") || videoSrc.includes("youtu.be")) {
                        iframeSrc = videoSrc + "?autoplay=1&enablejsapi=1";
                    } else if (videoSrc.includes("rutube.ru")) {
                        iframeSrc = videoSrc + "?autoplay=1";
                    } else {
                        console.error(`Unsupported video platform: ${videoSrc}`);
                        return;
                    }

                    const iframe = document.createElement("iframe");
                    iframe.src = iframeSrc;
                    iframe.frameborder = "0";
                    iframe.allow = "autoplay; encrypted-media";
                    iframe.allowfullscreen = true;

                    // Заменяем превью на iframe с видео
                    videoContainer.innerHTML = "";
                    videoContainer.appendChild(iframe);
                    videoContainer.classList.add("loaded");
                }

                // Ставим на паузу все видео, кроме активного
                this.slides.forEach(function (slide) {
                    const iframe = slide.querySelector("iframe");
                    if (iframe && slide !== activeSlide) {
                        if (iframe.src.includes("youtube.com")) {
                            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
                        } else if (iframe.src.includes("rutube.ru")) {
                            iframe.contentWindow.postMessage('{"method":"pause"}', "*");
                        }
                    }
                });
            },
        },
    });

    // partners swiper
    var partnersSlider = new Swiper(".partners-slider", {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
        },
        breakpoints: {
            340: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 5,
                spaceBetween: 16,
            },
            1280: {
                slidesPerView: 6,
                spaceBetween: 16,
            },
        },
    });

    var poolsPlusSlider = new Swiper(".pools-plus-slider", {
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: true,
        observer: true,
        observeParents: true,
        grabCursor: true,
        loop: true,
        speed: 1000,
        pagination: {
            el: ".pools-plus-pagination",
        },
        navigation: {
            nextEl: ".pools-plus-button-next",
            prevEl: ".pools-plus-button-prev",
        },
        breakpoints: {
            1024: {
                slidesPerView: 2,
                spaceBetween: 16,
                autoHeight: false,
            },
        },
    });

    var poolsRealizedSlider = new Swiper(".pools-realized-slider", {
        slidesPerView: 1,
        spaceBetween: 16,
        simulateTouch: false,
        touchRatio: 0,
        autoHeight: true,
        loop: true,
        speed: 1000,
        navigation: {
            nextEl: ".pools-realized-button-next",
            prevEl: ".pools-realized-button-prev",
        },
        pagination: {
            el: ".pools-realized-pagination",
        },
    });
});

// sticky header
document.addEventListener("DOMContentLoaded", function () {
    var header = document.querySelector(".header");
    var prevScrollPos = window.pageYOffset;
    var isFixed = false;
    var isHidden = false;

    if (header) {
        var updateHeaderStyles = function () {
            var currentScrollPos = window.pageYOffset;

            if (currentScrollPos > 0 && !isFixed) {
                header.classList.add("is-fixed");
                isFixed = true;
            } else if (currentScrollPos === 0 && isFixed) {
                header.classList.remove("is-fixed");
                isFixed = false;
            }

            prevScrollPos = currentScrollPos;
        };

        updateHeaderStyles();
        window.addEventListener("scroll", updateHeaderStyles);
    }
});

// tabs-stages
document.addEventListener("DOMContentLoaded", function () {
    const tabSets = document.querySelectorAll(".stages-tabs-nav");

    tabSets.forEach((tabSet) => {
        const tabsNav = tabSet.querySelectorAll("li");
        const tabsContent = tabSet.nextElementSibling.querySelectorAll(".stages-tabs-tabpanel");

        tabsNav.forEach((tab, index) => {
            tab.addEventListener("click", () => {
                tabsNav.forEach((item) => item.classList.remove("active"));
                tabsContent.forEach((item) => item.classList.remove("active"));

                tab.classList.add("active");
                tabsContent[index].classList.add("active");
            });
        });
    });
});

// input file
document.addEventListener("DOMContentLoaded", function () {
    const inputFile = document.querySelector('.form-field input[type="file"]');
    const fileNameSpan = document.querySelector(".input-file span");
    const inputFileContainer = document.querySelector(".input-file");
    const removeFileButton = document.querySelector(".remove-file");

    if (inputFileContainer) {
        inputFileContainer.addEventListener("click", function (event) {
            if (event.target.closest(".remove-file")) {
                // Предотвращаем всплытие события, чтобы не открывалось окно выбора файла
                event.stopPropagation();
                inputFile.value = "";
                fileNameSpan.textContent = "Прикрепите файл";
                removeFileButton.style.display = "none";
            } else {
                inputFile.click();
            }
        });
    }

    if (inputFile) {
        inputFile.addEventListener("change", function () {
            const allowedExtensions = ["pdf", "doc", "docx", "xls", "xlsx"];
            const file = inputFile.files[0];

            if (file) {
                const fileExtension = file.name.split(".").pop().toLowerCase();
                if (allowedExtensions.includes(fileExtension)) {
                    const fileName = file.name;
                    const extensionIndex = fileName.lastIndexOf(".");
                    const baseName = fileName.substring(0, extensionIndex);
                    const extension = fileName.substring(extensionIndex);

                    let displayName;
                    if (baseName.length > 10) {
                        displayName = baseName.substring(0, 10) + "..." + extension;
                    } else {
                        displayName = fileName;
                    }

                    fileNameSpan.textContent = displayName;
                    removeFileButton.style.display = "flex";
                } else {
                    alert("Недопустимый тип файла. Пожалуйста, выберите файл с расширением .pdf, .doc, .docx, .xls или .xlsx.");
                    inputFile.value = "";
                    fileNameSpan.textContent = "Прикрепите файл";
                    removeFileButton.style.display = "none";
                }
            } else {
                fileNameSpan.textContent = "Прикрепите файл";
                removeFileButton.style.display = "none";
            }
        });
    }
});
